import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PercentageIcon from "@mui/icons-material/Percent";
import InfoRow from "../common/InfoRow";
import StatusChip from "../common/StatusChip";
import { CompanyChargeResponseDto } from "../../shared/dtos/companyCharge/CompanyChargeResponseDto";

interface CompanyChargeCardProps {
  companyCharge: CompanyChargeResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const CompanyChargeCard: React.FC<CompanyChargeCardProps> = ({
  companyCharge,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }} noWrap>
              {companyCharge.name}
            </Typography>

            <Box sx={{ mt: 0.5, display: "flex", gap: 1, flexWrap: "wrap" }}>
              <StatusChip
                status={companyCharge.chargeType}
                sx={{ height: 20, fontSize: "0.65rem" }}
              />
              <StatusChip
                status={companyCharge.isTaxable ? "TAXABLE" : "NON_TAXABLE"}
              />
            </Box>
          </Box>
          <Stack direction="row">
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={2} sx={{ flexGrow: 1 }}>
          <InfoRow
            icon={<PercentageIcon fontSize="small" />}
            label="Rate"
            value={`${Number(companyCharge.rate).toFixed(2)} %`}
          />
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default CompanyChargeCard;
